import React, { memo } from 'react'
import { Handle, Position } from 'reactflow'

const StartNode: React.FC = () => {
  return (
    <div className="node px py">
      <p><i className="fa fa-flag"/> Iniciar</p>
      <Handle
        id="start"
        type="source"
        position={Position.Bottom}
        style={{ bottom: 3, width: 12, height: 12, background: '#ff4081' }}
      />
    </div>
  )
}

export default memo(StartNode)
